const ENDPOINT_CENTER_WHITE_MARK = '/secure/white-mark/center/:centerId'
const ENDPOINT_WHITE_MARK_ID = '/secure/white-mark/:whiteMarkId'
const ENDPOINT_WHITE_MARK = '/secure/white-mark'
const ENDPOINT_DOMAINS = '/domains'
const ENDPOINT_DOMAIN_AVAILABILITY =
  '/secure/is/:subDomain/availables/:domainName'

export const state = () => ({})

export const mutations = {}

export const getters = {}

export const actions = {
  async fetchCenterWhiteMarks({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        ENDPOINT_CENTER_WHITE_MARK.replace(':centerId', payload)
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async fetchMyWhiteMarks({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        ENDPOINT_WHITE_MARK + '?owner=' + payload
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async fetchWhiteMarkById({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        ENDPOINT_WHITE_MARK + '?id=' + payload
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async fetchDomains({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(ENDPOINT_DOMAINS)
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async checkDomainAvailability({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        ENDPOINT_DOMAIN_AVAILABILITY.replace(
          ':subDomain',
          payload.subDomain
        ).replace(':domainName', payload.domainName)
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async deleteWhiteMark({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.delete(
        ENDPOINT_WHITE_MARK_ID.replace(':whiteMarkId', payload)
      )
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async updateWhiteMark({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.patch(
        ENDPOINT_WHITE_MARK_ID.replace(':whiteMarkId', payload.whiteMarkId),
        payload.model
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async createWhiteMark({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.post(ENDPOINT_WHITE_MARK, payload)
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  }
}
